// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: "https://j5i5717b5j.execute-api.ap-south-1.amazonaws.com/Prod",
  stripeKey: "pk_test_51KidUeGEhXuuPdiQsGWmFLPyOlYJsBnh1epNDh4uU53SOv9tJgxODfvRuRKPRoIXRmkYIKwYmhNeyLv3tafIqJLL00LkoY5Inv",
  stripeServerUrl: "https://stripepay.ipossoft.com",
  currency: "AED"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
